import {
  Breadcrumb,
  ErrorAlert,
  Modal,
  modalHandler,
  ModalOpenBtn,
  PageHero,
  TableRowsPerPage,
  TruckIcon,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import { useDriversPage } from "../hooks";
import DriverForm from "../components/DriverForm";
import React from "react";

const DriversPage = () => {
  const {
    drivers,
    columns,
    isLoading,
    error,
    totalItems,
    pg,
    updatePg,
    refetch,
    editingDriver,
    closeModal,
    searchName,
    updateSearchName,
  } = useDriversPage();

  const handleSuccess = () => {
    modalHandler();
    refetch();
    closeModal();
  };

  return (
    <>
      <ErrorAlert reload={refetch} show={error} />
      <Breadcrumb links={[{ name: "المناديب", link: "" }]} />

      <Modal
        size="max-w-5xl"
        close={closeModal}
        title={editingDriver ? "تعديل مندوب" : "اضافة مندوب جديد"}
      >
        <DriverForm editData={editingDriver} onSuccess={handleSuccess} />
      </Modal>

      <main className="table-card relative">
        <PageHero
          eyebrow="العمليات / المناديب"
          title="المناديب"
          count={totalItems}
          icon={TruckIcon}
          hideCount={isLoading}
        >
          <input
            value={searchName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              updateSearchName(e.target.value)
            }
            type="search"
            placeholder="بحث بالاسم"
            className="single-search-input"
          />

          <TableRowsPerPage
            pagination={{ ...pg, rows: totalItems }}
            rowsPerPageOptions={[5, 10, 15, 25]}
            onRowsPerPageChange={(size: number) => updatePg({ size, page: 1 })}
          />

          <ModalOpenBtn style="btn-green" title="اضافة " />
        </PageHero>

        <DataTable
          data={drivers}
          columns={columns}
          isLoading={isLoading}
          pagination={{ ...pg, rows: totalItems }}
          onPageChange={(page: number) => updatePg({ page })}
          onPageSizeChange={(size: number) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default DriversPage;
